module.exports = __webpack_public_path__ + "img/apm-bizum.ad31afb5.svg";